<template>
  <div
    id="repairTicketEditor"
    class="vh80"
  >
    <v-card class="tickets-container screen-height-container flex-content">
      <v-card-title class="tickets-title">
        <h2>New Ticket</h2>
        <v-spacer />
        <v-btn
          icon
          @click="$emit('close')"
          ><v-icon>close</v-icon></v-btn
        >
      </v-card-title>

      <v-card-text
        class="tickets-container d-flex flex-column overflow-auto h-100 pa-0"
        style="position: relative"
      >
        <transition
          name="slide-in"
          mode="out-in"
        >
          <EmergencyTicket
            key="emergency"
            class="px-5 pb-3 w-100"
            style="position: absolute"
            v-if="wizardStep === 0"
            @next="onNonEmergency"
          />
        </transition>
        <transition
          :name="categoryTransitionName"
          mode="out-in"
        >
          <div
            key="category"
            class="px-5 pb-3 w-100"
            style="position: absolute"
            v-if="wizardStep === 1"
          >
            <div class="d-flex justify-space-around align-center py-5">
              <CategoryButton
                icon="water_drop"
                text="Irrigation"
              />
              <CategoryButton
                icon="cloud_queue"
                text="Air"
              />
              <CategoryButton
                icon="wb_incandescent"
                text="Lights"
              />
            </div>
          </div>
        </transition>
        <transition
          :name="subcategoryTransitionName"
          mode="out-in"
        >
          <component
            key="subcategory"
            class="px-5 pb-3 w-100"
            style="position: absolute"
            v-if="subcategoryComponentType && wizardStep === 2"
            :is="subcategoryComponentType"
          />
        </transition>
        <transition
          :name="vfuTransitionName"
          mode="out-in"
        >
          <VfuSelection
            key="vfuSelection"
            class="px-5 pb-3 w-100"
            style="position: absolute"
            v-if="wizardStep === 3"
          />
        </transition>
        <transition
          name="slide-out"
          mode="out-in"
        >
          <IssueDescription
            key="issueDescription"
            class="px-5 pb-3 w-100"
            style="position: absolute"
            v-if="wizardStep === 4"
          />
        </transition>
      </v-card-text>
      <v-card-actions class="d-flex pb-2">
        <v-btn
          v-if="wizardStep >= 1"
          @click="onGoBack"
          elevation="5"
          ><v-icon>arrow_back</v-icon>Back</v-btn
        >
        <v-btn
          v-if="wizardStep === 3"
          class="ml-auto"
          @click="onContinue"
          elevation="5"
          :disabled="!this.canGoNext"
          >Continue<v-icon>arrow_forward</v-icon></v-btn
        >
        <v-btn
          v-if="wizardStep === 4"
          class="ml-auto"
          @click="saveTicket"
          color="primary"
          :loading="isSaving"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import moment from 'moment';
import vuetifyToast from '@/vuetifyToast.js';
import Trimaster from '@/plugins/servers/trimaster.js';
import VuetifyDatePicker from '@/components/util/VuetifyDatepicker.vue';
import VuetifyTimePicker from '@/components/util/VuetifyTimepicker.vue';
import UploadButton from 'vuetify-upload-button';
import UploadImage from '@/components/util/UploadImage';
import AirSubcategorySelection from '@/components/repairTickets/SubcategorySelection/AirSubcategorySelection.vue';
import IrrigationSubcategorySelection from '@/components/repairTickets/SubcategorySelection/IrrigationSubcategorySelection.vue';
import LightsSubcategorySelection from '@/components/repairTickets/SubcategorySelection/LightsSubcategorySelection.vue';
import CategoryButton from '@/components/repairTickets/CategoryButton.vue';
import VfuSelection from '@/components/repairTickets/VfuSelection.vue';
import IssueDescription from '@/components/repairTickets/DescribeIssue/IssueDescription.vue';
import EmergencyTicket from '@/components/repairTickets/EmergencyTickets/EmergencyTicket.vue';
const env = process.env;

export default {
  name: 'CreateNewRepairTicket',
  components: {
    VuetifyDatePicker,
    VuetifyTimePicker,
    UploadButton,
    UploadImage,
    AirSubcategorySelection,
    IrrigationSubcategorySelection,
    LightsSubcategorySelection,
    CategoryButton,
    VfuSelection,
    IssueDescription,
    EmergencyTicket,
  },
  data() {
    return {
      Trimaster: Trimaster,
      failureDate: moment().format('YYYY-MM-DD'),
      failureTime: moment().format('HH:mm'),
      emergencyTransitionName: 'slide-out',
      categoryTransitionName: 'slide-out',
      subcategoryTransitionName: 'slide-out',
      vfuTransitionName: 'slide-out',
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    ...mapGetters('repairTickets', [
      'wizardStep',
      'selectedCategory',
      'selectedSubcategory',
      'selectedAssets',
      'issueDescription',
    ]),
    subcategoryComponentType() {
      return this.selectedCategory ? `${this.selectedCategory}SubcategorySelection` : null;
    },
    canGoNext() {
      switch (this.wizardStep) {
        case 1:
          return !!this.selectedCategory;
        case 2:
          return !!this.selectedSubcategory;
        case 3:
          return !!this.selectedAssets.length;
        case 4:
          return this.issueDescription.length;
      }
    },
  },
  watch: {
    selectedCategory(newValue) {
      if (newValue) {
        this.categoryTransitionName = 'slide-in';
        this.subcategoryTransitionName = 'slide-out';
        this.$nextTick(() => {
          this.$store.dispatch('repairTickets/setWizardStep', 2);
        });
      }
    },
    selectedSubcategory(newValue) {
      if (newValue) {
        this.subcategoryTransitionName = 'slide-in';
        this.vfuTransitionName = 'slide-out';
        this.$nextTick(() => {
          this.$store.dispatch('repairTickets/setWizardStep', 3);
        });
      }
    },
    wizardStep(newValue) {
      switch (newValue) {
        case 1:
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          break;
      }
    },
  },
  beforeMount() {
    this.$store.dispatch('repairTickets/reset');
  },
  methods: {
    onNonEmergency() {
      // this.categoryTransitionName = 'slide-out';
      // this.$store.dispatch('repairTickets/setWizardStep', 1);
      this.categoryTransitionName = 'slide-in';
      this.subcategoryTransitionName = 'slide-out';
      this.$nextTick(() => {
        this.categoryTransitionName = 'slide-out';
        this.$store.dispatch('repairTickets/setWizardStep', 1);
      });
    },
    onGoBack() {
      console.log('this.wizardStep', this.wizardStep);
      switch (this.wizardStep) {
        case 1:
          this.goBackToEmergency();
          break;
        case 2:
          this.goBackToCategory();
          break;
        case 3:
          this.goBackToSubcategory();
          break;
        case 4:
          this.goBackToVfuSelection();
          break;
      }
    },
    onContinue() {
      if (!this.canGoNext) {
        return;
      }
      switch (this.wizardStep) {
        case 1:
          break;
        case 2:
          break;
        case 3:
          this.vfuTransitionName = 'slide-in';
          this.$nextTick(() => {
            this.$store.dispatch('repairTickets/setWizardStep', 4);
          });
          break;
        case 4:
          break;
      }
    },
    goBackToEmergency() {
      this.emergencyTransitionName = 'slide-in';
      this.categoryTransitionName = 'slide-out';
      this.$nextTick(() => {
        this.$store.dispatch('repairTickets/setWizardStep', 0);
      });
    },
    goBackToCategory() {
      this.categoryTransitionName = 'slide-in';
      this.subcategoryTransitionName = 'slide-out';
      this.$nextTick(() => {
        this.$store.dispatch('repairTickets/setSelectedCategory', null);
        this.$store.dispatch('repairTickets/setWizardStep', 1);
      });
    },
    goBackToSubcategory() {
      this.subcategoryTransitionName = 'slide-in';
      this.$nextTick(async () => {
        this.$store.dispatch('repairTickets/setSelectedSubcategory', null);
        await this.$store.dispatch('repairTickets/setWizardStep', 2);
        this.$nextTick(() => {
          this.subcategoryTransitionName = 'slide-out';
        });
      });
    },
    goBackToVfuSelection() {
      this.vfuTransitionName = 'slide-in';
      this.$nextTick(async () => {
        this.$store.dispatch('repairTickets/setSelectedAssets', []);
        await this.$store.dispatch('repairTickets/setWizardStep', 3);
        this.$nextTick(() => {
          this.vfuTransitionName = 'slide-out';
        });
      });
    },
    fileChanged(file) {
      let type = file.type.split('/')[1];
      if (type == 'png' || type == 'mp4' || type == 'jpg' || type == 'jpeg') {
        let vm = this;
        vm.isLoading = true;

        let formData = new FormData();

        let originalName = file.name.split('.');

        let blob = file.slice(0, file.size, file.type);
        file = new File(
          [blob],
          `${env.VUE_APP_trimaster}-hardware-item-ticket-${Math.random().toString(36).substring(7)}-${vm.getUser.id}.${
            originalName[originalName.length - 1]
          }`,
          {
            type: file.type,
          }
        );

        formData.append('file', file);

        Trimaster.post(
          `hardware_item_tickets/s3Upload`,
          vm.getUser.apitoken,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
          {
            bucket: 'hardware-item-tickets',
          }
        ).then(function (data) {
          vm.isLoading = false;
          let path = data[0][0];
          vm.imageUrl = path;
          vuetifyToast.success('File has been uploaded!');
        });
      } else {
        vuetifyToast.error('File type is invalid! Please upload png, jpg, jpeg, or mp4 files.');
      }
    },
    async saveTicket() {
      this.isSaving = true;
      const ticketInfo = {
        selectedCategory: this.$store.state.repairTickets.selectedCategory,
        selectedSubcategory: this.$store.state.repairTickets.selectedSubcategory,
        selectedAssets: this.$store.state.repairTickets.selectedAssets,
        issueDescription: this.$store.state.repairTickets.issueDescription,
      };

      let description = `${this.$store.state.repairTickets.selectedCategory} - ${this.$store.state.repairTickets.selectedSubcategory}<br/>`;
      if (this.$store.state.repairTickets.selectedAssets.length) {
        description += `Affected Assets:<br/>`;
        description += this.$store.state.repairTickets.selectedAssets.map((asset) => asset.name).join(', ');
        description += `<br/>`;
      }
      if (this.$store.state.repairTickets.issueDescription) {
        description += this.$store.state.repairTickets.issueDescription;
      }
      let createdTicket = await Trimaster.post('repairTickets/createRepairTicket', this.getUser.apitoken, {
        name: `${this.$store.state.repairTickets.selectedCategory} - ${this.$store.state.repairTickets.selectedSubcategory}`,
        description: description,
        problemDate: moment.utc(),
        imageUrl: '',
        imageUrl2: '',
        imageUrl3: '',
        imageUrl4: '',
        platformGroupIds: this.$store.state.repairTickets.selectedAssets
          .filter((asset) => asset.type !== 'asset')
          .map((asset) => asset.id),
        assets: this.$store.state.repairTickets.selectedAssets.filter((asset) => asset.type === 'asset'),
      });
      this.isSaving = false;
      vuetifyToast.success('Ticket created successfully');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
#repairTicketEditor {
  .slide-in-enter-active,
  .slide-in-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-in-enter,
  .slide-in-leave-to {
    transform: translateX(-100%);
  }

  .slide-out-enter-active,
  .slide-out-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-out-enter,
  .slide-out-leave-to {
    transform: translateX(100%);
  }

  .new-ticket-container {
    margin-top: 15px;
    overflow: auto;
  }

  .fullHeight {
    height: 100%;
  }

  .tickets-container {
    padding-top: 0;
  }

  .tickets-container .v-text-field {
    padding-top: 0px;
  }

  .tickets-container .v-input--selection-controls {
    margin-top: 0px;
  }

  .tickets-container .row {
    margin: 0px !important;
  }

  .tickets-container label {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
  }

  .tickets-container .v-input--selection-controls__input {
    margin-right: 0px !important;
  }

  .tickets-container .momentumscrolling {
    -webkit-overflow-scrolling: touch;
  }

  .tickets-title {
    padding-bottom: 0;
  }

  .tickets-buttons-container {
    text-align: right;
    padding: 15px 0 15px 0;
  }

  .ticket-description {
    margin-top: 15px;
  }
}
</style>
